import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import sectionBg from '../assets/images/banner.webp';

const Banner = ({ page }) => {
    const isBlogDetail = page?.type === 'blog';

    return (
        <section className={`${isBlogDetail ? 'blog-detail' : ''} banner bg-primary`} style={{ backgroundImage: `url(${sectionBg})` }}>
            <Container>
                <div className="col-lg-12 text-center wow fadeInUp">                
                    {isBlogDetail && page.attributes.categories?.length > 0 && (
                        <ul className="list-inline mt-2">
                            {page.attributes.categories.map((category) => (
                                <li key={category.slug} className="list-inline-item mx-1 p-15 opacity-7">                          
                                    <Link
                                        to={`/category/${category.slug}`}
                                        className="text-decoration-none fw-500 badge bg-light text-dark d-flex align-items-center pe-2"
                                        >
                                            <span className={category.icon_class ? category.icon_class : 'icon-blog' }></span>
                                            {category.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    )}
                    <h1>{page.title}</h1>                    
                    {isBlogDetail && page.attributes.author_image && (
                        <ul className="post-meta d-flex align-items-center justify-content-center">
                            <li className="d-flex">
                                <Link to="/about-me" className="d-flex align-items-center">
                                    {(
                                        <img
                                            src={page.attributes.author_image}
                                            alt={page.attributes.author_name}
                                            width={30}
                                            className="img-fluid rounded-circle me-2"
                                        />
                                    )}                                     
                                </Link>
                                <div className="name-wrp d-flex align-items-center">
                                    <span className="prefix">By</span>
                                    <Link className="text-dark"to="/about-me">{page.attributes.author_name}</Link>
                                </div>
                            </li>
                            <li className="d-flex"><span className="op-md">{page.attributes.post_date}</span></li>
                        </ul>
                    )}
                </div>
            </Container>
        </section>
    );
};

Banner.propTypes = {
    page: PropTypes.shape({
        title: PropTypes.string.isRequired,
        type: PropTypes.string,
        categories: PropTypes.arrayOf(
            PropTypes.shape({
                slug: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            })
        ),
    }).isRequired,
};

export default Banner;
